define( function() {
	return window.document;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/document.js